import { getBestOfArticlesIndexPath } from 'site-modules/editorial/utils/content-path';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getPageOptions } from 'site-modules/editorial/pages/research-article/best-of-article/best-of-article-definition';
import { TwoColumnBest } from './two-column-best';

const pages = new Map();
export default ({ bestOfCategory, articleId, chunkName }) => {
  const key = getBestOfArticlesIndexPath(bestOfCategory, articleId);
  let page = pages.get(key);
  if (!page) {
    page = pageDefinition(getPageOptions({ bestOfCategory, articleId, chunkName, pageTemplate: TwoColumnBest }));
    pages.set(key, page);
  }
  return page;
};
